import FraseDelGiorno from '../nav/FraseDelGiorno';

/**
 * DashboardTopBar — barra superiore: titolo, "Frase del giorno", anno corrente.
 * Estratta da Dashboard.jsx. Stateless, riceve `annoNum`.
 */
export default function DashboardTopBar({ annoNum }) {
  return (
    <div className="border-b border-line">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <div className="flex items-baseline gap-2 pl-12 lg:pl-0 min-w-0 overflow-hidden">
          <span className="font-mono text-xs text-soft shrink-0">Dashboard Anno</span>
          <FraseDelGiorno />
        </div>
        <div className="flex items-baseline gap-3">
          <span className="font-mono text-xs uppercase tracking-[0.2em] text-soft">Anno</span>
          <span className="font-mono text-lg" data-testid="anno-corrente">{annoNum}</span>
        </div>
      </div>
    </div>
  );
}
